import { render, staticRenderFns } from "./ResponsiveYoutubeWrapper.vue?vue&type=template&id=0525179f&"
import script from "./ResponsiveYoutubeWrapper.vue?vue&type=script&lang=js&"
export * from "./ResponsiveYoutubeWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports